import { graphql } from "../gql";

export default graphql(`
  query getEfficiencyStats($input: OddsMarketTypesInput!) {
    event(input: $input) {
      homeTeam {
        abbreviation
        shortName
        logoSVG
        primaryColor
        secondaryColor
        teamStats {
          efficiencyStats {
            adjDefNEP
            adjDefPassNEP
            adjDefRushNEP
            adjOffNEP
            adjOffPassNEP
            adjOffRushNEP
          }
        }
      }
      awayTeam {
        abbreviation
        shortName
        logoSVG
        primaryColor
        secondaryColor
        teamStats {
          efficiencyStats {
            adjDefNEP
            adjDefPassNEP
            adjDefRushNEP
            adjOffNEP
            adjOffPassNEP
            adjOffRushNEP
          }
        }
      }
    }
  }
`);
